<script setup lang="ts">
import {defineProps, computed} from 'vue';
import HistoryAccountEntriesDownloadButton
  from "@/components/history/HistoryAccountEntriesDownloadButton.vue";
import HistoryCsvDownloadButtonNew from "@/components/history/HistoryCsvDownloadButtonNew.vue";

const props = defineProps({
  accountNumber: {type: String, default: ''},
  periodBegin: {type: String, default: ''},
  periodEnd: {type: String, default: ''},
  state: {type: String, default: null},
  textSearch: {type: String, default: ''},
})

const accountNumber = computed(() => props.accountNumber)
const periodBegin = computed(() => props.periodBegin)
const periodEnd = computed(() => props.periodEnd)
const state = computed(() => props.state)
const textSearch = computed(() => props.textSearch)
</script>

<template>
  <div>
    <h3>{{ $t('Выписка и экспорт истории платежей') }}</h3>

    <div class="divider">
      <div>
        <HistoryAccountEntriesDownloadButton :account-number="accountNumber"
                                             :period-begin="periodBegin" :period-end="periodEnd"

        ></HistoryAccountEntriesDownloadButton>
        <div class="csv-hint">
          {{$t('line1')}}
          <br/>
          {{$t('line2')}}
        </div>
      </div>
      <div>
        <HistoryCsvDownloadButtonNew
          :period-begin="periodBegin"
          :period-end="periodEnd"
          :state="state"
          :text-search="textSearch"
          :accountNumber="accountNumber"/>
        <div class="csv-hint">
          {{ $t('line3' )}}
          <br/>
          {{ $t('line4')}}
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="less">
.divider {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  align-items: flex-start;
  gap: 5%;
  flex-wrap: nowrap;
  > div {
    flex-grow: 1;
    flex-basis: fit-content;
    flex-shrink: 0.5;
  }
}
.csv-hint {
  font-size: 12px;
  color: #666;
  margin-top: 1em;
}
</style>


<i18n>
{
  "en": {
    "line1": "The Statement contains the history of successful payments for the selected account for all time without taking into account the filter.",
    "Выписка и экспорт истории платежей": "Statement and export of payment history",
    "line2": "The Statement also contains the account balance.",
    "line3": "Unlike the Statement, the export contains payments taking into account the filter.",
    "line4": "The export also does not contain account balances."
  },
  "ru": {
    "line1": "Выписка содержит историю успешных платежей по выбранному счету за все время без учета фильтра.",
    "line2": "Также выписка содержит баланс счета.",
    "line3": "В отличие от выписки, экспорт содержит платежи с учетом фильтра.",
    "line4": "Также экспорт не содержит балансы счетов."
  }
}
</i18n>
